import Vue from 'vue' //引入vue
import VueRouter from "vue-router" //引入vue-router
import Layout from '@/layout' //布局页
import LayoutHome from '@/views/home/home.vue' //布局页
Vue.use(VueRouter) //第三方库需要use一下才能用

export const constRouter = [{
        path: '/home',
        component: LayoutHome,
        hidden: true, //导航菜单忽略选项
        children: [{
            path: '/home',
            name: 'home',
            title: '中心首页',
            component: () =>
                import ('@/views/home/index.vue'),
        }, {
            path: '/introduction',
            name: 'introduction',
            title: '中心简介 ',
            component: () =>
                import ('@/views/home/viewList/introduction.vue'),

        }, {
            path: '/industry',
            name: 'industry',
            title: '行业动态 ',
            component: () =>
                import ('@/views/home/viewList/trendsList.vue'),
        }, {
            path: '/notice',
            name: 'notice',
            title: '通知公告 ',
            component: () =>
                import ('@/views/home/viewList/noticeList.vue'),
        }, {
            path: '/meeting',
            name: 'meeting',
            title: '会议会训 ',
            component: () =>
                import ('@/views/home/viewList/meetingList.vue'),
        }, {
            path: '/noticedetail',
            name: 'noticedetail',
            title: '通知公告详情 ',
            hidden: true,
            component: () =>
                import ('@/views/home/viewDetails/noticeDetail.vue'),
        }, {
            path: '/meetingdetail',
            name: 'meetingdetail',
            title: '会议会训详情 ',
            hidden: true,
            component: () =>
                import ('@/views/home/viewDetails/meetingDetail.vue'),
        }, {
            path: '/trendsdetail',
            name: 'trendsdetail',
            title: '行业动态详情 ',
            hidden: true,
            component: () =>
                import ('@/views/home/viewDetails/trendsDetail.vue'),
        }]
    },
    {
        path: '',
        component: LayoutHome,
        hidden: true, //导航菜单忽略选项
        children: [{
            path: '',
            name: '',
            title: '中心首页',
            component: () =>
                import ('@/views/home/index.vue'),
        }]
    }
]

const asyncRoutes = []

const router = new VueRouter({
    routes: constRouter,
});

export default router